import { domain } from 'modules/data';

export function isNewUser(user: domain.User, company: domain.Company) {
    return (
        !!(company.tempUsers || {})[user.id] && !company.participants.some((participantId) => participantId === user.id)
    );
}
